

export const convertCamelCaseToReadable = (input: string) => null != input && input != "" ? input
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between lowercase and uppercase letters
        .replace(/^./, (str) => str.toUpperCase()) : ""; // Uppercase the first character